import { AppBar, Box, Button, Drawer, Stack, Toolbar, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../redux/hooks";
import { useAppDispatch } from "../redux/hooks";
import { logout } from "../redux/slices/auth.slice";
import { localUser } from "../utils/localUser";
import IconButton from '@mui/material/IconButton';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { NavListDrawer } from "./NavListDrawer";
import { NavLinkItem } from "./NavBar.types";

type NavbarProps = {
    navComunLinks: NavLinkItem[];
    navAdminLinks: NavLinkItem[];
};

export const NavBar: React.FC<NavbarProps> = ({ navComunLinks, navAdminLinks }) => {
    const {userData} = useAppSelector((state) => state.authReducer)
    const navigate = useNavigate();

    const dispatch = useAppDispatch();  
    const handleLogout = () => {
        dispatch(logout());
        localUser.borrar();
        navigate('/login');
    }
    const [open, setOpen] = useState(false);

    return (
        <>
            <Box sx={{ flexGrow: 1 }} >
                <AppBar position="static">  {/* Analizar usar poition = "fixed"*/}
                    <Toolbar>
                        <IconButton 
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2, 
                                display: {xs:"block", sm:"none"}
                            }}
                            //onClick={()=> navigate("/")}
                            onClick={()=>setOpen(true)}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography
                            component="div"
                            variant="h6" 
                            sx={{ flexGrow: 1 }}
                        >
                            WebRoka
                        </Typography>
                        <Stack direction= "row" spacing={1} sx={{display: {xs:"none", sm:"block"}}} >
                            <>
                                {navComunLinks.map((link)=> (
                                    <Button 
                                    variant= "contained" 
                                    key = {link.path}
                                    onClick={()=> navigate(link.path)} 
                                    startIcon={link.icon}
                                    size="large"
                                    color="secondary"
                                    >
                                        {link.title}
                                    </Button>                                    
                                ))}
                            </>
                            {userData?.role === "ADMIN" ? (
                            <>
                                {navAdminLinks.map((link)=> (
                                    <Button 
                                    variant= "contained" 
                                    key = {link.path}
                                    onClick={()=> navigate(link.path)} 
                                    startIcon={link.icon}
                                    size="large"
                                    color="secondary"
                                    >
                                        {link.title}
                                    </Button>                                    
                                ))}
                            </>
                            ):
                            <></>
                            }   
                                <Button 
                                variant= "contained" 
                                onClick={()=> handleLogout()} 
                                startIcon={<LogoutIcon />}
                                size="large"
                                color="secondary"
                                >
                                    Logout
                                </Button>
                        </Stack>
                        <Box sx={{ ml: 1 }} />
                        <PersonIcon />
                        <Typography
                            component="div"
                            variant="h6"
                        >
                            {`${userData?.name}`}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Drawer 
                open={open} 
                onClose={() => setOpen(false)}>
                <NavListDrawer 
                    navComunLinks={navComunLinks} 
                    navAdminLinks={navAdminLinks}
                    setOpen={setOpen}
                />
            </Drawer>
        </>
    )
}

